export enum UIType {
  OPEN_GIG_START_CONFIRMATION_MODAL = 'OPEN_GIG_START_CONFIRMATION_MODAL',
  CLOSE_GIG_START_CONFIRMATION_MODAL = 'CLOSE_GIG_START_CONFIRMATION_MODAL',
  OPEN_GIG_END_CONFIRMATION_MODAL = 'OPEN_GIG_END_CONFIRMATION_MODAL',
  CLOSE_GIG_END_CONFIRMATION_MODAL = 'CLOSE_GIG_END_CONFIRMATION_MODAL',
  SHOW_DEAD_MANS_HANDLE = 'SHOW_DEAD_MANS_HANDLE',
  SHOW_STREAM_MODAL = 'SHOW_STREAM_MODAL',
  HIDE_STREAM_MODAL = 'HIDE_STREAM_MODAL',
  TOGGLE_MODAL = 'TOGGLE_MODAL',
  SHOW_SETTINGS_MODAL = 'SHOW_SETTINGS_MODAL',
  HIDE_SETTINGS_MODAL = 'HIDE_SETTINGS_MODAL',
  SHOW_RESCHEDULED_MODAL = 'SHOW_RESCHEDULED_MODAL',
  HIDE_RESCHEDULED_MODAL = 'HIDE_RESCHEDULED_MODAL',
  SHOW_PLAY_IN_MODAL = 'SHOW_PLAY_IN_MODAL',
  HIDE_PLAY_IN_MODAL = 'HIDE_PLAY_IN_MODAL',
  SHOW_SLIDES_UPLOAD_MODAL = 'SHOW_SLIDES_UPLOAD_MODAL',
  HIDE_SLIDES_UPLOAD_MODAL = 'HIDE_SLIDES_UPLOAD_MODAL',

  TOGGLE_MEDIA_DRAWER = 'TOGGLE_MEDIA_DRAWER',
  OPEN_PLAY_IN_MEDIA_DRAWER = 'OPEN_PLAY_IN_MEDIA_DRAWER',
  CLOSE_PLAY_IN_MEDIA_DRAWER = 'CLOSE_PLAY_IN_MEDIA_DRAWER',
  OPEN_SLIDES_MEDIA_DRAWER = 'OPEN_SLIDES_MEDIA_DRAWER',
  CLOSE_SLIDES_MEDIA_DRAWER = 'CLOSE_SLIDES_MEDIA_DRAWER',
  OPEN_SPOTLIGHT_MEDIA_DRAWER = 'OPEN_SPOTLIGHT_MEDIA_DRAWER',
  CLOSE_SPOTLIGHT_MEDIA_DRAWER = 'CLOSE_SPOTLIGHT_MEDIA_DRAWER',
  OPEN_SIDE_PANEL = 'OPEN_SIDE_PANEL',
  CLOSE_SIDE_PANEL = 'CLOSE_SIDE_PANEL',
  SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM',
  SET_FEATURE_FLAG = 'SET_FEATURE_FLAG',
  WINDOW_FOCUS = 'WINDOW_FOCUS',
  WINDOW_BLUR = 'WINDOW_BLUR'
}
